import moment from "moment"

moment.locale("pt-BR")

export function differBetweenHours(startHour, endHour) {
  const differBetweenHours = moment(endHour, "HH:mm").diff(
    moment(startHour, "HH:mm")
  )

  const differenceInMinutes = moment.duration(differBetweenHours / 1000 / 60)
    ._milliseconds

  return differenceInMinutes
}

export default differBetweenHours
